<template>
    <div class="auth__twofactorauth_form">
        <div class="container">
            <div class="columns is-variable">
                <div class="column">
                    <div class="auth__twofactorauth_form_box">
                        <div class="auth__twofactorauth_form_box_title">{{ $t('auth.twoFactorAuth.title') }}</div>
                        <div class="auth__twofactorauth_form_box_fields">
                            <form-text
                                :label="$t('auth.twoFactorAuth.labels.backupCode')"
                                :name="'twofactorauth-email'"
                                :value="''"
                            />
                            <form-checkbox
                                :label="$t('auth.twoFactorAuth.labels.rememberThisDevice')"
                                :name="'twofactorauth-remember'"
                                :value="''"
                            />
                        </div>
                        <div class="auth__twofactorauth_form_box_actions">
                            <component-button
                                :name="'auth-twofactorauth-form-box-actions-verify'"
                                :theme="'primary'"
                                :size="'full'"
                            >{{ $t('auth.twoFactorAuth.buttons.verify') }}</component-button>
                            <component-button
                                :name="'auth-twofactorauth-form-box-actions-help'"
                                :theme="'primary'"
                                :inverse="true"
                                :size="'full'"
                                :to="{ name: 'auth-two-factor-help' }"
                            >{{ $t('auth.twoFactorAuth.buttons.troubleReceivingCode') }}
                            </component-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormText from '@/components/default/forms/FormText'
import ComponentButton from '@/components/default/shared/ComponentButton'
import FormCheckbox from '@/components/default/forms/FormCheckbox'

export default {
  name: 'auth-twofactorauth-form',
  components: { FormCheckbox, ComponentButton, FormText }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/auth/twofactorauth/authtwofactorauthform";
</style>
